export default __webpack_public_path__ + "static/media/apple.3ba8b5c2.png";